module.exports = __webpack_public_path__ + "static/media/14.5452c06e.jpeg";